<template>
  <div class="animated fadeIn">
    <AppHeader></AppHeader>
    <div class="app-body">
      <Sidebar></Sidebar>
      <main class="main">
        <div class="container-fluid">
          <router-view></router-view>
        </div>
      </main>
    </div>
    <ScrollTop></ScrollTop>
    <FaqModal></FaqModal>
  </div>
</template>

<script>
  import dashboard from '../../_dash';
  import {mapActions} from 'vuex';
  import Sidebar from '../../components/eventManagement/sidebar/Sidebar.vue';
  import AppHeader from '../../components/eventManagement/header/Header.vue';
  import ScrollTop from '../../components/utils/ScrollTop';
  import FaqModal from '@/components/modal/FaqModal';
  import consts from '@/_consts';
  import routerConstanst from '@/router/constants';

  export default {
    name: 'home',
    components: {
      AppHeader,
      Sidebar,
      ScrollTop,
      FaqModal
    },
    data () {
      return {
        dashboardCards: dashboard.items
      };
    },
    methods: {
      ...mapActions({
      })
    },
    created () {
      let clientId = parseInt(localStorage.getItem(consts.LOCAL_STORE.clientId));
      if (clientId !== 0 && this.$route.params.clientId.toString() !== clientId.toString()) {
        this.$router.push({
          name: routerConstanst.clientDashboard.name,
          params: {
            clientId: clientId
          }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '../../styles/variables.less';

  .app-body {
    min-height: 100vh;
  }
</style>



// WEBPACK FOOTER //
// ManagerDashboard.vue?4105d362